"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var index_1 = require("../../index");
var card_1 = __importDefault(require("./card"));
function MarketCardComponent(props) {
    var _a = props.flexTitle, flexTitle = _a === void 0 ? '' : _a, desc = props.desc, flexSmallTitle = props.flexSmallTitle, mergeComponentStatus = props.mergeComponentStatus, _b = props.cardList, cardList = _b === void 0 ? [] : _b;
    return (react_1.default.createElement("div", { className: "intl-market-card" },
        react_1.default.createElement("div", { className: "intl-market-card__container" },
            (flexTitle || desc || flexSmallTitle) && (react_1.default.createElement(index_1.FlexTitle, { flexTitle: flexTitle, desc: desc, mergeComponentStatus: mergeComponentStatus, flexSmallTitle: flexSmallTitle })),
            react_1.default.createElement("section", { className: "wrap" },
                react_1.default.createElement(card_1.default, { cardList: cardList })))));
}
function MarketCard(props) {
    var paddingTopNum = props.paddingTopNum, paddingBottomNum = props.paddingBottomNum, flexTitle = props.flexTitle, style = props.style;
    return (react_1.default.createElement(index_1.CommonContainer, { paddingTopNum: paddingTopNum, paddingBottomNum: paddingBottomNum, flexTitle: flexTitle, style: style },
        react_1.default.createElement(MarketCardComponent, __assign({}, props))));
}
exports.default = MarketCard;
//# sourceMappingURL=MarketCard.js.map